// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/channel.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/channel.proto.
 */
export const file_agentplatform_v1_channel: GenFile = /*@__PURE__*/
  fileDesc("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", [file_gnostic_openapi_v3_annotations, file_google_api_field_behavior]);

/**
 * @generated from message infinigence.infini.agentplatform.v1.ChannelCapabilities
 */
export type ChannelCapabilities = Message<"infinigence.infini.agentplatform.v1.ChannelCapabilities"> & {
  /**
   * 支持的聊天类型
   * @gotags: json:"chat_types,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.ChatType chat_types = 1 [json_name = "chat_types"];
   */
  chatTypes: ChatType[];

  /**
   * 是否支持多媒体
   * @gotags: json:"media,omitempty"
   *
   * @generated from field: bool media = 2;
   */
  media: boolean;

  /**
   * 是否支持流式
   * @gotags: json:"streaming,omitempty"
   *
   * @generated from field: bool streaming = 3;
   */
  streaming: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ChannelCapabilities.
 * Use `create(ChannelCapabilitiesSchema)` to create a new message.
 */
export const ChannelCapabilitiesSchema: GenMessage<ChannelCapabilities> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 0);

/**
 * @generated from message infinigence.infini.agentplatform.v1.Channel
 */
export type Channel = Message<"infinigence.infini.agentplatform.v1.Channel"> & {
  /**
   * 名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 类型
   * @gotags: json:"type"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelType type = 2;
   */
  type: ChannelType;

  /**
   * 能力
   * @gotags: json:"capabilities,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelCapabilities capabilities = 3;
   */
  capabilities?: ChannelCapabilities | undefined;

  /**
   * 状态
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelStatus status = 4;
   */
  status: ChannelStatus;

  /**
   * 首次上线时间
   * @gotags: json:"first_seen_at,omitempty"
   *
   * @generated from field: int64 first_seen_at = 5 [json_name = "first_seen_at"];
   */
  firstSeenAt: bigint;

  /**
   * 最后离线时间
   * @gotags: json:"last_offline_at,omitempty"
   *
   * @generated from field: int64 last_offline_at = 6 [json_name = "last_offline_at"];
   */
  lastOfflineAt: bigint;

  /**
   * 创建时间
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 7 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * 更新时间， 一般指更新状态的时间
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 8 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * 数据库主键（列表/更新时必须带回，否则 UPDATE 会因 id 为空失败）
   * @gotags: json:"id"
   *
   * @generated from field: string id = 9;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Channel.
 * Use `create(ChannelSchema)` to create a new message.
 */
export const ChannelSchema: GenMessage<Channel> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 1);

/**
 * @generated from message infinigence.infini.agentplatform.v1.ChannelAccountCredential
 */
export type ChannelAccountCredential = Message<"infinigence.infini.agentplatform.v1.ChannelAccountCredential"> & {
  /**
   * 应用ID
   * @gotags: json:"app_id,omitempty"
   *
   * @generated from field: string app_id = 1 [json_name = "app_id"];
   */
  appId: string;

  /**
   * 应用密钥
   * @gotags: json:"app_secret,omitempty"
   *
   * @generated from field: string app_secret = 2 [json_name = "app_secret"];
   */
  appSecret: string;

  /**
   * 渠道账号 token（bridge 等 channel type 按需使用，opaque string，语义由 driver 决定）
   * @gotags: json:"token,omitempty"
   *
   * @generated from field: string token = 3;
   */
  token: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ChannelAccountCredential.
 * Use `create(ChannelAccountCredentialSchema)` to create a new message.
 */
export const ChannelAccountCredentialSchema: GenMessage<ChannelAccountCredential> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 2);

/**
 * @generated from message infinigence.infini.agentplatform.v1.ChatPolicy
 */
export type ChatPolicy = Message<"infinigence.infini.agentplatform.v1.ChatPolicy"> & {
  /**
   * 允许的单聊来源
   * @gotags: json:"p2p_allow_from,omitempty"
   *
   * @generated from field: repeated string p2p_allow_from = 1 [json_name = "p2p_allow_from"];
   */
  p2pAllowFrom: string[];

  /**
   * 是否禁用群聊
   * @gotags: json:"disable_group,omitempty"
   *
   * @generated from field: bool disable_group = 2 [json_name = "disable_group"];
   */
  disableGroup: boolean;

  /**
   * 允许的群聊来源
   * @gotags: json:"group_allow_from,omitempty"
   *
   * @generated from field: repeated string group_allow_from = 3 [json_name = "group_allow_from"];
   */
  groupAllowFrom: string[];

  /**
   * 调用 VibeAgent 时的 _caller_user_id 使用 ChannelUser 的哪个字段
   * 可选值: "channel_user_id", "open_id", "username", "email", "phone"
   * 默认空字符串 = 使用 channel_user_id（旧行为）
   * @gotags: json:"caller_user_id_field,omitempty"
   *
   * @generated from field: string caller_user_id_field = 4 [json_name = "caller_user_id_field"];
   */
  callerUserIdField: string;

  /**
   * 是否在卡片中展示工具调用详情（默认 true，保持旧行为）
   * @gotags: json:"show_tool_calls,omitempty"
   *
   * @generated from field: bool show_tool_calls = 5 [json_name = "show_tool_calls"];
   */
  showToolCalls: boolean;

  /**
   * 是否禁用单聊
   * @gotags: json:"disable_p2p,omitempty"
   *
   * @generated from field: bool disable_p2p = 6 [json_name = "disable_p2p"];
   */
  disableP2p: boolean;

  /**
   * 审批者名单
   * @gotags: json:"approvers,omitempty"
   *
   * @generated from field: repeated string approvers = 7;
   */
  approvers: string[];

  /**
   * 未命中系统斜杠指令时是否转成 agent 输入运行。
   * 默认 false = 走 /help 兜底（旧行为）；true = 把原始消息当作 agent 输入交主流程，
   * 用于「在 agent 内部处理的斜杠指令」。
   * @gotags: json:"unknown_command_as_agent_input,omitempty"
   *
   * @generated from field: bool unknown_command_as_agent_input = 8 [json_name = "unknown_command_as_agent_input"];
   */
  unknownCommandAsAgentInput: boolean;

  /**
   * 自我审批人员名单
   * @gotags: json:"self_approvers,omitempty"
   *
   * @generated from field: repeated string self_approvers = 9 [json_name = "self_approvers"];
   */
  selfApprovers: string[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ChatPolicy.
 * Use `create(ChatPolicySchema)` to create a new message.
 */
export const ChatPolicySchema: GenMessage<ChatPolicy> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 3);

/**
 * @generated from message infinigence.infini.agentplatform.v1.ChannelAccount
 */
export type ChannelAccount = Message<"infinigence.infini.agentplatform.v1.ChannelAccount"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 资源名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 租户ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 3 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 4 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 渠道类型
   * @gotags: json:"type"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelType type = 5;
   */
  type: ChannelType;

  /**
   * 渠道账号凭证
   * @gotags: json:"credential,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccountCredential credential = 6;
   */
  credential?: ChannelAccountCredential | undefined;

  /**
   * 是否禁用
   * @gotags: json:"disabled,omitempty"
   *
   * @generated from field: bool disabled = 7;
   */
  disabled: boolean;

  /**
   * 聊天策略
   * @gotags: json:"chat_policy,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChatPolicy chat_policy = 8 [json_name = "chat_policy"];
   */
  chatPolicy?: ChatPolicy | undefined;

  /**
   * 账号状态
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.AccountStatus status = 9;
   */
  status: AccountStatus;

  /**
   * 智能体ID（INSTANCE 模式下为 Application ID，TEMPLATE 模式下为 Agent 模版 ID）
   * @gotags: json:"agent_id,omitempty"
   *
   * @generated from field: string agent_id = 10 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * 首次上线时间
   * @gotags: json:"first_online_at,omitempty"
   *
   * @generated from field: int64 first_online_at = 11 [json_name = "first_online_at"];
   */
  firstOnlineAt: bigint;

  /**
   * 最后离线时间
   * @gotags: json:"last_offline_at,omitempty"
   *
   * @generated from field: int64 last_offline_at = 12 [json_name = "last_offline_at"];
   */
  lastOfflineAt: bigint;

  /**
   * 创建时间
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 13 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * 更新时间
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 14 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * 删除时间
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 15 [json_name = "deleted_at"];
   */
  deletedAt: bigint;

  /**
   * 绑定模式：INSTANCE=agent_id 指向 Application，TEMPLATE=agent_id 指向 Agent 模版
   * @gotags: json:"binding_mode,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccountBindingMode binding_mode = 16 [json_name = "binding_mode"];
   */
  bindingMode: ChannelAccountBindingMode;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ChannelAccount.
 * Use `create(ChannelAccountSchema)` to create a new message.
 */
export const ChannelAccountSchema: GenMessage<ChannelAccount> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 4);

/**
 * ChannelUserBinding 记录模板绑定渠道账号下用户与 Application 实例的映射关系
 *
 * @generated from message infinigence.infini.agentplatform.v1.ChannelUserBinding
 */
export type ChannelUserBinding = Message<"infinigence.infini.agentplatform.v1.ChannelUserBinding"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 渠道账号 ID
   * @gotags: json:"account_id"
   *
   * @generated from field: string account_id = 2 [json_name = "account_id"];
   */
  accountId: string;

  /**
   * 渠道用户 ID
   * @gotags: json:"channel_user_id"
   *
   * @generated from field: string channel_user_id = 3 [json_name = "channel_user_id"];
   */
  channelUserId: string;

  /**
   * Agent 模版 ID
   * @gotags: json:"agent_id"
   *
   * @generated from field: string agent_id = 4 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * 用户专属的 Application 实例 ID
   * @gotags: json:"application_id"
   *
   * @generated from field: string application_id = 5 [json_name = "application_id"];
   */
  applicationId: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 6 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 创建时间
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 7 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * 更新时间
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 8 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * 删除时间
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 9 [json_name = "deleted_at"];
   */
  deletedAt: bigint;

  /**
   * 用户渠道信息快照（/init 时记录）
   * @gotags: json:"channel_user,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelUser channel_user = 10 [json_name = "channel_user"];
   */
  channelUser?: ChannelUser | undefined;

  /**
   * 工具自动审批白名单
   * @gotags: json:"tool_permissions,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ToolPermissions tool_permissions = 11 [json_name = "tool_permissions"];
   */
  toolPermissions?: ToolPermissions | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ChannelUserBinding.
 * Use `create(ChannelUserBindingSchema)` to create a new message.
 */
export const ChannelUserBindingSchema: GenMessage<ChannelUserBinding> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 5);

/**
 * 工具权限规则
 * 匹配粒度：先按 tool_name 匹配，再按参数值正则过滤
 *
 * @generated from message infinigence.infini.agentplatform.v1.ToolPermissionRule
 */
export type ToolPermissionRule = Message<"infinigence.infini.agentplatform.v1.ToolPermissionRule"> & {
  /**
   * 工具名称，如 "exec", "file_editor", "*"（所有工具）
   * @gotags: json:"tool_name"
   *
   * @generated from field: string tool_name = 1 [json_name = "tool_name"];
   */
  toolName: string;

  /**
   * 参数名，如 "command", "path"；为空表示不按参数过滤
   * @gotags: json:"argument,omitempty"
   *
   * @generated from field: string argument = 2;
   */
  argument: string;

  /**
   * RE2 正则表达式，参数值匹配此正则时规则生效；为空表示无条件匹配该工具
   * @gotags: json:"pattern,omitempty"
   *
   * @generated from field: string pattern = 3;
   */
  pattern: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ToolPermissionRule.
 * Use `create(ToolPermissionRuleSchema)` to create a new message.
 */
export const ToolPermissionRuleSchema: GenMessage<ToolPermissionRule> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 6);

/**
 * 工具权限配置，包含允许和拒绝两条规则列表
 * 评估顺序：deny 优先 → 如果 deny 列表有匹配，直接拒绝
 * 然后 allow 列表 → 如果有匹配，自动通过审批
 * 无匹配 → default_action（默认需人工审批）
 *
 * @generated from message infinigence.infini.agentplatform.v1.ToolPermissions
 */
export type ToolPermissions = Message<"infinigence.infini.agentplatform.v1.ToolPermissions"> & {
  /**
   * 允许自动审批的规则列表
   * @gotags: json:"allow,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.ToolPermissionRule allow = 1;
   */
  allow: ToolPermissionRule[];

  /**
   * 拒绝执行的规则列表（优先级高于 allow）
   * @gotags: json:"deny,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.ToolPermissionRule deny = 2;
   */
  deny: ToolPermissionRule[];

  /**
   * 无规则命中时的默认行为
   * @gotags: json:"default_action,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ToolPermissionDefaultAction default_action = 3 [json_name = "default_action"];
   */
  defaultAction: ToolPermissionDefaultAction;

  /**
   * 触发人工审批时是否调用 LLM 生成一句中文意图描述（HITL enable_desc）
   * @gotags: json:"enable_desc,omitempty"
   *
   * @generated from field: bool enable_desc = 4 [json_name = "enable_desc"];
   */
  enableDesc: boolean;

  /**
   * 生成意图描述使用的模型名，留空使用 vibe-agent 默认模型
   * @gotags: json:"desc_model,omitempty"
   *
   * @generated from field: string desc_model = 5 [json_name = "desc_model"];
   */
  descModel: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ToolPermissions.
 * Use `create(ToolPermissionsSchema)` to create a new message.
 */
export const ToolPermissionsSchema: GenMessage<ToolPermissions> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 7);

/**
 * @generated from message infinigence.infini.agentplatform.v1.ChannelUser
 */
export type ChannelUser = Message<"infinigence.infini.agentplatform.v1.ChannelUser"> & {
  /**
   * 渠道用户ID (如 "feishu:zhangsan" 或 QQ raw ID)
   * @gotags: json:"channel_user_id,omitempty"
   *
   * @generated from field: string channel_user_id = 1 [json_name = "channel_user_id"];
   */
  channelUserId: string;

  /**
   * 渠道 Open ID (如飞书 open_id)
   * @gotags: json:"open_id,omitempty"
   *
   * @generated from field: string open_id = 2 [json_name = "open_id"];
   */
  openId: string;

  /**
   * 用户名/昵称
   * @gotags: json:"username,omitempty"
   *
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * 邮箱
   * @gotags: json:"email,omitempty"
   *
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * 手机号
   * @gotags: json:"phone,omitempty"
   *
   * @generated from field: string phone = 5;
   */
  phone: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ChannelUser.
 * Use `create(ChannelUserSchema)` to create a new message.
 */
export const ChannelUserSchema: GenMessage<ChannelUser> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 8);

/**
 * @generated from message infinigence.infini.agentplatform.v1.ChannelP2PSession
 */
export type ChannelP2PSession = Message<"infinigence.infini.agentplatform.v1.ChannelP2PSession"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ChannelP2PSession.
 * Use `create(ChannelP2PSessionSchema)` to create a new message.
 */
export const ChannelP2PSessionSchema: GenMessage<ChannelP2PSession> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 9);

/**
 * @generated from message infinigence.infini.agentplatform.v1.ChannelSessionState
 */
export type ChannelSessionState = Message<"infinigence.infini.agentplatform.v1.ChannelSessionState"> & {
  /**
   * @gotags: json:"p2p,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.ChannelP2PSession p2p = 1;
   */
  p2p: ChannelP2PSession[];

  /**
   * @gotags: json:"current_index,omitempty"
   *
   * @generated from field: int32 current_index = 2 [json_name = "current_index"];
   */
  currentIndex: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ChannelSessionState.
 * Use `create(ChannelSessionStateSchema)` to create a new message.
 */
export const ChannelSessionStateSchema: GenMessage<ChannelSessionState> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 10);

/**
 * @generated from message infinigence.infini.agentplatform.v1.ChannelSession
 */
export type ChannelSession = Message<"infinigence.infini.agentplatform.v1.ChannelSession"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 2 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * @gotags: json:"account_id"
   *
   * @generated from field: string account_id = 3 [json_name = "account_id"];
   */
  accountId: string;

  /**
   * @gotags: json:"channel_user_id"
   *
   * @generated from field: string channel_user_id = 4 [json_name = "channel_user_id"];
   */
  channelUserId: string;

  /**
   * @gotags: json:"state,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelSessionState state = 7;
   */
  state?: ChannelSessionState | undefined;

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 8 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 9 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 10 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ChannelSession.
 * Use `create(ChannelSessionSchema)` to create a new message.
 */
export const ChannelSessionSchema: GenMessage<ChannelSession> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_channel, 11);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.ChannelType
 */
export enum ChannelType {
  /**
   * 未指定
   *
   * @generated from enum value: CHANNEL_TYPE_UNSPECIFIED = 0;
   */
  CHANNEL_TYPE_UNSPECIFIED = 0,

  /**
   * 飞书
   *
   * @generated from enum value: FEISHU = 1;
   */
  FEISHU = 1,

  /**
   * QQ
   *
   * @generated from enum value: QQ = 2;
   */
  QQ = 2,

  /**
   * 自定义 WebSocket 通道（业务方接入自有 APP/SDK）
   *
   * @generated from enum value: BRIDGE = 3;
   */
  BRIDGE = 3,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.ChannelType.
 */
export const ChannelTypeSchema: GenEnum<ChannelType> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_channel, 0);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.ChatType
 */
export enum ChatType {
  /**
   * 未指定
   *
   * @generated from enum value: CHAT_TYPE_UNSPECIFIED = 0;
   */
  CHAT_TYPE_UNSPECIFIED = 0,

  /**
   * 单聊
   *
   * @generated from enum value: P2P = 1;
   */
  P2P = 1,

  /**
   * 群聊
   *
   * @generated from enum value: GROUP = 2;
   */
  GROUP = 2,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.ChatType.
 */
export const ChatTypeSchema: GenEnum<ChatType> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_channel, 1);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.ChannelStatus
 */
export enum ChannelStatus {
  /**
   * unknown
   *
   * @generated from enum value: CHANNEL_STATUS_UNKNOWN = 0;
   */
  CHANNEL_STATUS_UNKNOWN = 0,

  /**
   * online
   *
   * @generated from enum value: ONLINE = 1;
   */
  ONLINE = 1,

  /**
   * offline
   *
   * @generated from enum value: OFFLINE = 2;
   */
  OFFLINE = 2,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.ChannelStatus.
 */
export const ChannelStatusSchema: GenEnum<ChannelStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_channel, 2);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.AccountStatus
 */
export enum AccountStatus {
  /**
   * unknown
   *
   * @generated from enum value: ACCOUNT_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * online
   *
   * @generated from enum value: ACCOUNT_STATUS_ONLINE = 1;
   */
  ONLINE = 1,

  /**
   * offline
   *
   * @generated from enum value: ACCOUNT_STATUS_OFFLINE = 2;
   */
  OFFLINE = 2,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.AccountStatus.
 */
export const AccountStatusSchema: GenEnum<AccountStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_channel, 3);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.ChannelAccountBindingMode
 */
export enum ChannelAccountBindingMode {
  /**
   * agent_id 指向 Application 实例（旧行为）
   *
   * @generated from enum value: INSTANCE = 0;
   */
  INSTANCE = 0,

  /**
   * agent_id 指向 Agent 模版（新行为），终端用户需要 /init 创建专属实例
   *
   * @generated from enum value: TEMPLATE = 1;
   */
  TEMPLATE = 1,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.ChannelAccountBindingMode.
 */
export const ChannelAccountBindingModeSchema: GenEnum<ChannelAccountBindingMode> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_channel, 4);

/**
 * 无 allow/deny 规则命中时的默认动作，对齐 vibe-agent HITL middleware default_action。
 *
 * @generated from enum infinigence.infini.agentplatform.v1.ToolPermissionDefaultAction
 */
export enum ToolPermissionDefaultAction {
  /**
   * 未设置：生成 HITL 时按 REQUIRE_HUMAN 处理（兼容旧配置）
   *
   * @generated from enum value: TOOL_PERMISSION_DEFAULT_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 直接拒绝（HITL: deny）
   *
   * @generated from enum value: TOOL_PERMISSION_DEFAULT_ACTION_DENY = 1;
   */
  DENY = 1,

  /**
   * 人工审批（HITL: require_human）
   *
   * @generated from enum value: TOOL_PERMISSION_DEFAULT_ACTION_REQUIRE_HUMAN = 2;
   */
  REQUIRE_HUMAN = 2,

  /**
   * 自动批准（HITL: auto_approve）
   *
   * @generated from enum value: TOOL_PERMISSION_DEFAULT_ACTION_AUTO_APPROVE = 3;
   */
  AUTO_APPROVE = 3,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.ToolPermissionDefaultAction.
 */
export const ToolPermissionDefaultActionSchema: GenEnum<ToolPermissionDefaultAction> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_channel, 5);

